import { SUPPORT_EMAIL } from "../../constants/emails";
import { ExternalLinkText } from "../coreUI/ExternalLink";
import { useAuth } from "../providers/AuthProvider";

export function ContactSupportCard() {
  const { user } = useAuth();
  const userID = user;
  const SUPPORT_EMAIL_TEXT = {
    SUBJECT_LINE: "Membership Management Inquiry",
    EMAIL_BODY: `Hi Samphire team,\n\nI need help with my membership.\n\n{Explain issue here.}\n\nMy user ID is ${userID}.`,
  } as const;

  return (
    <div>
      <p className="text-sm text-foreground-secondary flex flex-row gap-0.5">
        Need help with your account?{" "}
      </p>
      <ExternalLinkText
        href={`mailto:${SUPPORT_EMAIL.TO_ADDRESS}?subject=${encodeURIComponent(SUPPORT_EMAIL_TEXT.SUBJECT_LINE)}&body=${encodeURIComponent(SUPPORT_EMAIL_TEXT.EMAIL_BODY)}`}
        text="Contact Support"
        className="text-sm text-foreground-primary"
      />
    </div>
  );
}
